import {Helmet} from "react-helmet";
import Header from "./components/Header";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Map from "./pages/Map";
import BrokenElevators from "./pages/BrokenElevators";
import React from "react";

const App = () => {

    return (
        <div>
            <Helmet>
                <title>LIFT</title>
                <meta name="description" content="Panel admina LIFT" />
            </Helmet>
            <Header />
            <Router>
                <Switch>
                    <Route
                        path='/'
                        exact component = {Map}
                    />
                    <Route
                        path='/map'
                        exact component = {Map}
                    />
                    <Route
                        path='/malfunctions'
                        exact component = {BrokenElevators}
                    />
                    <Route
                        path='*'
                        component={() => "404 NOT FOUND"}
                    />
                    {/* should be some component NoMatch */}
                </Switch>
            </Router>
        </div>
    );
}

export default App